import React from 'react';
import { Modal, Card, Form, DatePicker } from 'antd';
import { connect } from 'dva';
import { formItemLayoutModal } from 'utils/utils.js';
import moment from 'moment';
import styles from './Delay.less';

const FormItem = Form.Item;

@connect(({ operationChargeItem, loading }) => ({
  show: operationChargeItem.modal.showDelay,
  submitting: loading.effects['operationChargeItem/delay'],
  id: operationChargeItem.modal.rowData.id,
}))
@Form.create()
export default class Delay extends React.Component {
  constructor(props) {
    super(props);

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleHideModal = this.handleHideModal.bind(this);
  }

  handleSubmit() {
    const { form, id } = this.props;

    form.validateFields((err, values) => {
      if (!err) {
        const { dispatch } = this.props;

        dispatch({
          type: 'operationChargeItem/delay',
          gmtEnd: values.gmtEnd,
          id,
        }).then(() => {
          this.handleHideModal();
          dispatch({ type: 'operationChargeItem/toggleRefreshFlag' });
        });
      }
    });
  }

  handleHideModal() {
    this.props.dispatch({
      type: 'operationChargeItem/toggleModalVisibility',
      modal: {
        showDelay: false,
      },
    });
  }

  render() {
    const { show, form, submitting } = this.props;

    if (show === false) {
      return null;
    }

    const { getFieldDecorator } = form;

    return (
      <Modal
        title="延期"
        className={styles.root}
        confirmLoading={submitting}
        visible
        onOk={this.handleSubmit}
        onCancel={this.handleHideModal}
      >
        <Card bordered={false}>
          <Form className={styles.root}>
            <FormItem {...formItemLayoutModal} label="截止时间">
              {getFieldDecorator('gmtEnd', {
                rules: [{ required: true, message: '请选择截止时间' }],
              })(
                <DatePicker
                  format="YYYY-MM-DD HH:mm:ss"
                  showTime={{
                    defaultValue: moment('23:59:59', 'HH:mm:ss'),
                  }}
                  disabledDate={d => {
                    if (!d) {
                      return false;
                    }

                    return (
                      moment(d)
                        .startOf('day')
                        .diff(moment().startOf('day')) < 0
                    );
                  }}
                />
              )}
            </FormItem>
          </Form>
        </Card>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes/Operation/ChargeItem/Modal/Delay.js